import dayjs from "dayjs"
import ctrans from "./trans"
// import { getLocaleIETF } from "./auth"


// export function formatBool(value: number | string): string {
//     if(value === "false" || value === "no") {
//         return trans("no")
//     }
//     return !!value ? trans("yes") : trans("no")
// }


export function formatVoid(value) {
    return value
}

export function formatNumber(number, options = {}) {
    const locale = 'cs-CZ'

    return Number(!number ? 0 : number).toLocaleString(locale, { ...options, maximumFractionDigits: 2 })
}

export function formatInt(number) {
    const locale = 'cs-CZ'

    return Number(!number ? 0 : number).toLocaleString(locale, {maximumFractionDigits: 0})
}



/**
 * Formats price according to locale
 * @param price
 * @param disabled
 * @returns {string}
 */
export function formatPrice(price: number, heureka_locale: string | undefined, round = false, options: any = {}): string {
    const locale = heureka_locale === "cz" ? "cs-CZ" : "sk-SK"
    const currency = heureka_locale === "cz" ? "CZK" : "EUR"
    if(price === null) {
        return "‒"
    }
    const o = { style: "currency", currency, currencyDisplay: "symbol", ...options }
    if (round) {
        if (currency === "CZK") {
            o.minimumFractionDigits = 0
            o.maximumFractionDigits = 0
        } else
            if (currency === "EUR") {
                o.minimumFractionDigits = 2
                o.maximumFractionDigits = 2
            }

    }
    return Number(!price ? 0 : price).toLocaleString(locale, o)
}


export function formatDate(date, options = {}) {
    if(!date) {
        return "‒"
    }
    const locale = 'cs-CZ'
    const d = new Date(date)
    return d.toLocaleDateString(locale, options)
}

export function formatDateShort(date) {
    if (!date) {
        return "‒"
    }
   return dayjs(date).format("D.\u00a0M.")
}

export function formatDatetime(datetime) {
    if (!datetime) {
        return "‒"
    }
    return dayjs(datetime).format("D.\u00a0M.\u00a0YYYY HH:mm:ss")
}


// /**
//  * Get number of days string
//  * @param date
//  * @param options
//  * @returns {string}
//  */
// export function formatDays(number): string {
//     if (number || number === 0) {
//         return trans("n_days", { n: number })
//     } else {
//         return "‒"
//     }
// }


// /**
//  * Formats PNO
//  * @param pno
//  * @param infinity
//  * @returns {string}
//  */
export function formatPNO(pno: number, infinity: boolean = false): string {
    if (infinity === true) {
        return "100\u00a0%"
    }
    if (pno === undefined || (!pno && pno !== 0)) {
        return "‒ %"
    }
    return pno.toLocaleString("cs-CZ", {maximumFractionDigits: 2}) + " %"
}


// export function formatQueryName(name: string) {
//     if(name === "♥ALLPRODUCTS♥") {
//         return trans("all_products")
//     }
//     return name
// }

// export function formatBudget(value: any, type: string) {
//     const formatter = type === "sales" || type === "costs" ? formatPrice : formatInt
//     return formatter(value)
// }

export function formatHeurekaDelivery(days: number) {
    if(days === null) {
        return ""
    } else
    if(days === 0) {
        return ctrans("IN_STOCK")
    } else if(days < 4) {
        return ctrans("THREE_DAYS")
    } else if(days < 8) {
        return ctrans("ONE_WEEK")
    } else if(days < 15) {
        return ctrans("TWO_WEEKS")
    } else if(days < 31) {
        return ctrans("MONTH")
    } else if(days >= 31) {
        return ctrans("MORE_THAN_MONTH")
    } else {
        return ctrans("UNKNOWN")
    }
}


